import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-docname-cell-renderer',
  template: `
  <div class="edit-cell-renderer">
    <div>{{docname}}</div>
    <div *ngIf="error" class="error-text">{{error}}</div>
  </div>
`
})
export class DocnameCellRendererComponent{

  docname = '';

  error = '';

  // gets called once before the renderer is used
  agInit(params: ICellRendererParams): void {
    if (params.data) {
      const data = params.data;
      if (data?.name) {
        this.docname = data.name;
      }
      if (data?.error) {
        this.error = data.error;
      }
    }
  }

  refresh(params: ICellRendererParams) {
  }
}
